import React, { useEffect, useState } from "react";
import { format as formatDate, parseISO } from "date-fns";
import axios from "axios";
import { useQuery } from "react-query";
import Swal from "sweetalert2";
import Participant from "./Participant";
import { url } from "../../../api";
import mic from "../../../assets/images/mic.svg";
import videoIcon from "../../../assets/images/videoIcon.svg";
import profileAvatar from "../../../assets/images/profile-avatar.jpg";

const Room = ({
  roomName,
  room,
  tracks,
  handleLogout,
  callType,
  userId,
  role,
}) => {
  const [participants, setParticipants] = useState([]);
  const [isVideo, setIsVideo] = useState(true);
  const [isAudio, setIsAudio] = useState(true);

  const token = localStorage.getItem("token");

  const headerToken = {
    headers: {
      "x-access-token": token,
    },
  };

  console.log("callType", callType);

  const getConsultationDetail = () => {
    return axios.get(
      `${url}/consultations/single-consultation/${roomName}`,
      headerToken
    );
  };

  const { isLoading, data } = useQuery(
    "ConsultationDetail",
    getConsultationDetail
  );
  console.log(data, isLoading);
  const consultationData = data?.data;
  console.log("consultationdata", data?.data);

  const profileImage =
    data?.data?.userId?.profilePicture !== ""
      ? `https://www.secondlookortho.com//${data?.data?.userId?.profilePicture}`
      : profileAvatar;

  console.log(
    `https://www.secondlookortho.com//${data?.data?.userId?.profilePicture}`
  );
  const docProfileImage =
    data?.data?.doctorId?.profilePicture !== ""
      ? `https://www.secondlookortho.com//${data?.data?.doctorId?.profilePicture}`
      : profileAvatar;

  useEffect(() => {
    const participantConnected = (participant) => {
      setParticipants((prevParticipants) => [...prevParticipants, participant]);
    };

    const participantDisconnected = (participant) => {
      setParticipants((prevParticipants) =>
        prevParticipants.filter((p) => p !== participant)
      );
    };

    room.on("participantConnected", participantConnected);
    room.on("participantDisconnected", participantDisconnected);
    room.participants.forEach(participantConnected);
    return () => {
      room.off("participantConnected", participantConnected);
      room.off("participantDisconnected", participantDisconnected);
    };
  }, []);

  const remoteParticipants =
    participants.length === 1 ? (
      participants.map((participant) => (
        <Participant
          remoteUser={true}
          key={participant.sid}
          participant={participant}
        />
      ))
    ) : (
      <div className="title"> Waiting for other participant to join .</div>
    );

  const getRedirection = () => {
    if (
      role &&
      userId !== data?.data?.doctorId?._id &&
      userId !== data?.data?.userId?._id
    ) {
      Swal.fire("Meeting Expired", "", "error");
      // history.push("/doctor/dashboard");
      window.location = "/doctor/dashboard";
    }
  };

  // on metting leave
  const onMeetingLeave = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to leave meeting?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Yes",

      confirmButtonColor: "#c82333",
    }).then((result) => {
      if (result.isConfirmed) {
        handleLogout();
      }
    });
  };

  console.log(tracks, "tracks in room");

  // main return
  return (
    <>
      <div className="basicRow waitingRoom px-0">
        <div className="videoDiv">
          <div className="videoControls">
            {callType === "video_call" ? (
              <button
                onClick={() => setIsVideo(!isVideo)}
                className={isVideo ? "" : "active"}
              >
                {/* {tracks.filter((e) => e?.kind === "video")>0 ? ( */}
                <img src={videoIcon} alt="video" className="icon" />
                {/* ) : (
                  <img
                    src="/icons/tools/remove-video-icon.svg"
                    alt="video"
                    className="icon"
                  />
                )} */}
              </button>
            ) : null}

            <button
              onClick={() => setIsAudio((prev) => !prev)}
              className={isAudio ? "" : "active"}
            >
              <img
                src={mic}
                alt="audio"
                className="icon"
                style={{ width: "12px" }}
              ></img>
            </button>
          </div>
          {remoteParticipants}
          <div className="myVideoDiv mb-[20px]">
            <Participant
              localUser
              isAudio={isAudio}
              isVideo={isVideo}
              key={room.localParticipant.sid}
              participant={room.localParticipant}
              constultationData={consultationData}
            />
          </div>
        </div>
        {isLoading || (
          <>
            {/* <div className="flex justify-around gap-[10px] mt-[10px] w-[90vw]">
              {getRedirection()}
              <div className="  header">
                <img
                  src={profileImage}
                  alt="profile"
                  className="img object-cover"
                ></img>
                <div className="md:ml-[20px]">
                  <div className="waitingText">Consulation room of</div>
                  <div className="name">
                    {`${data?.data?.userId?.firstName} ${data?.data?.userId?.lastName}`}
                  </div>
                  <div className="workText">Patient</div>
                </div>
              </div>
              <div className="  header">
                <img
                  src={docProfileImage}
                  alt="profile"
                  className="img object-cover"
                ></img>
                <div className="md:ml-[20px]">
                  <div className="waitingText">Doctor</div>
                  <div className="name">
                    {`Dr. ${data?.data?.doctorId?.firstName} ${data?.data?.doctorId?.lastName}`}{" "}
                  </div>
                  <div className="workText"></div>
                </div>
              </div>
            </div> */}
            <button
              onClick={onMeetingLeave}
              className="btn btn-danger mt-[30px] md:mt-[20px] md:w-[20%]"
            >
              Leave Meeting
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default Room;
